module.exports = __webpack_public_path__ + "img/banner_en.c3045d98.jpg";